/**
 * Element ids of the settings sections the sidebar search and the command palette can open.
 * A search result links to its page with the id as the URL hash; the page puts the id on the
 * section (or `data-search-sections` on a container that is always rendered, for sections that
 * only show in some states).
 */
export const SECTION_ANCHORS = {
  storeProfile: 'store-profile',
  primaryDomain: 'primary-domain',
  businessAddress: 'business-address',
  orderNumbers: 'order-numbers',
  currencies: 'currencies-locales',
  timeZone: 'time-zone',
  checkout: 'checkout-settings',
  tracking: 'tracking-ids',
  seoDefaults: 'seo-defaults',
  brandInSearch: 'brand-in-search',
  aiCrawlers: 'ai-crawlers',
  documents: 'packing-slips-invoices',
  productSearch: 'product-search',
  stripe: 'stripe-settings',
  stripeWebhook: 'stripe-webhook',
  applePay: 'apple-pay-domains',
  unpaidOrders: 'unpaid-orders',
  manualMethods: 'manual-payment-methods',
  emailSender: 'email-sender',
  taxCalculation: 'tax-calculation',
  taxRates: 'tax-rates',
  exchangeRates: 'exchange-rates',
  returnPolicy: 'return-policy',
  policyDocuments: 'policy-documents',
  policyFacts: 'policy-facts',
  feedSettings: 'feed-settings',
  allowedOrigins: 'allowed-origins',
  accountProfile: 'account-profile',
  signInEmail: 'sign-in-email',
  password: 'password-settings',
  sessions: 'signed-in-sessions',
  twoFactor: 'two-factor-settings',
  organizationProfile: 'organization-profile',
  requireTwoFactor: 'require-two-factor-settings',
  weightUnit: 'weight-unit-settings',
} as const;

export type SectionKey = keyof typeof SECTION_ANCHORS;
export type SectionAnchor = (typeof SECTION_ANCHORS)[SectionKey];
